import * as React from 'react';
import './PlaceholderImage.styles.less';
import { IPlaceholderImageProps } from "./PlaceholderImage.types";

export const PlaceholderImage = (props:IPlaceholderImageProps) =>
    <img className="placeholder-image" src={`https://picsum.photos/${props.width}/${props.height}`} />;
